import { render } from "./ReservationOrders.vue?vue&type=template&id=4abb60c1&scoped=true"
import script from "./ReservationOrders.vue?vue&type=script&lang=js"
export * from "./ReservationOrders.vue?vue&type=script&lang=js"

import "./ReservationOrders.vue?vue&type=style&index=0&id=4abb60c1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abb60c1"]])

export default __exports__